export default function ForgotPasswordController() {

}